module.exports = __webpack_public_path__ + "img/candle-holder.e4ec6fb8.svg";